import React, { useEffect, useState } from "react";
import Navbar from "../../../Components/Navbar";
import { useNavigate } from "react-router-dom";
import { apiPostFormData, Create_Api } from "../../../API/Api_Url";
import { toast } from "react-toastify";
import { ArrowLeft, Upload } from "lucide-react";
import { State, City as Citie } from "country-state-city";

function FreelancerSignUp() {
    const navigate = useNavigate()
    const [IsUploading, setIsUploading] = useState(false);
    const [step, setStep] = useState(1);
    const [fullName, setFullName] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [password, setPassword] = useState("");

    const [subRole, setSubRole] = useState("");
    const [location, setLocation] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [qualifications, setQualifications] = useState("");
    const [yearsOfExperience, setYearsOfExperience] = useState("");
    const [specializations, setSpecializations] = useState([]);
    const [employers, setEmployers] = useState("");
    const [serviceArea, setServiceArea] = useState("");
    const [additionalNotes, setAdditionalNotes] = useState("");
    const [Portfolioupload, setPortfolioupload] = useState(null);
    const [UploadID, setUploadID] = useState(null);

    const [openSpecialization, setOpenSpecialization] = useState(false);

    const specializationOptions = [
        "Structural Design",
        "QS",
        "Planning",
        "Estimation"
    ];

    const handleSpecializationSelect = (item) => {
        if (specializations.includes(item)) {
            setSpecializations(specializations.filter((i) => i !== item));
        } else {
            setSpecializations([...specializations, item]);
        }
    };




    const validateStep = () => {
        if (step === 1) {
            if (!fullName || !phoneNumber || !emailAddress || !password) {
                toast.error("Please fill all required fields in Basic Information.");
                return false;
            }
            const emailRegex = /\S+@\S+\.\S+/;
            if (!emailRegex.test(emailAddress)) {
                toast.error("Please enter a valid email address.");
                return false;
            }
            if (phoneNumber.length < 10) {
                toast.error("Please enter a valid phone number.");
                return false;
            }
        }
        return true;
    };

    const FreelanceRole = [
        'Land Surveyor',
        'Environmental Clearance Consultant',
        'Architect',
        'Structural Design Engineer(steel Str)',
        'RCC Design Engineer',
        'Electrical Design Engineer',
        'Plumbing Design Engineer',
        'HVAC Design Engineer',
        'Interior Designer',
        'Landscape Architect',
        'Vastu Consultant',
        'AR/VR House Demo Consultant',
        'Fire Safety NOC Consultant',
        'Project Management Consultant (PMC)',
        'Soil Testing Consultant / Geotechnical Engineer',
        'PSC design Engineer',
        'Rainwater Harvesting Consultant',
        'Registered Building Valuator (Chartered Engineer)',
        'Bank Loan Agents',
        '3D Visualizer / Walkthrough Specialist',
        'CADD Engineer / Draftsman',
        'Quantity Surveyor (QS)Estimation & BOQ ',
        'Site Engineer / Supervisor'
    ];

    const [SelectedState, setSelectedState] = useState("");
    const [SelectedDistrict, setSelectedDistrict] = useState("");

    const [Districts, setDistricts] = useState([]);
    const [Cities, setCities] = useState([]);

    useEffect(() => {
        if (SelectedState) {
            const stateCities = Citie.getCitiesOfState("IN", SelectedState);

            const uniqueDistricts = [
                ...new Set(stateCities.map((c) => c.stateCode + "-" + c.name)),
            ].map((key) => {
                const parts = key.split("-");
                return { name: parts[1], stateCode: parts[0] };
            });

            setDistricts(uniqueDistricts);
            setSelectedDistrict("");
            setCities([]);
        }
    }, [SelectedState]);

    useEffect(() => {
        if (SelectedDistrict) {
            const allCities = Citie.getCitiesOfState("IN", SelectedState);

            const filtered = allCities.filter(
                (city) => city.name === SelectedDistrict
            );

            setCities(filtered);
        }
    }, [SelectedDistrict]);

    const handleSubmit = async () => {
        const formData = new FormData();
        formData.append("fullName", fullName);
        formData.append("companyName", companyName);
        formData.append("phoneNumber", phoneNumber);
        formData.append("emailAddress", emailAddress);
        formData.append("password", password);
        formData.append("SubRole", subRole);
        formData.append("Location", location);
        formData.append("City", city);
        formData.append("address", address);
        formData.append("qualifications", qualifications);
        formData.append("yearsOfExperience", yearsOfExperience);
        formData.append("employers", employers);
        formData.append("serviceArea", SelectedDistrict);
        formData.append("additionalNotes", additionalNotes);
        specializations.forEach((spec, index) => {
            formData.append(`specializationsOfExpertise[${index}]`, spec);
        });
        if (Portfolioupload) formData.append("Portfolioupload", Portfolioupload);
        if (UploadID) formData.append("UploadID", UploadID);

        try {
            setIsUploading(true);
            const response = await apiPostFormData(
                `api/freelance-engineer/register1`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            console.log("Register Successful:", response?.data);
            if (response?.statusCode == 200) {
                localStorage.removeItem("UserType");
                localStorage.removeItem("user");
                localStorage.removeItem("userToken");
                localStorage.setItem("UserType", "freelanceEngineer");
                localStorage.setItem("user", JSON.stringify(response?.data?.freelanceEngineer));
                localStorage.setItem("userToken", response?.data?.tokens?.accessToken);
                toast.success(response?.message);
                navigate("/");
                setTimeout(() => window.location.reload(), 3000);
            }
            else {
                toast.error(response?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.error(error);
        } finally {
            setIsUploading(false);
        }
    };


    return (
        <>
            <Navbar />
            <div className="AllSignupPadding">
                <div className="flex justify-center">
                    <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl border border-gray-200 p-10">
                        <div className="relative flex items-center mb-10">
                            <button
                                onClick={() => navigate(-1)}
                                className="absolute left-0 text-gray-700 hover:text-black transition"
                            >
                                <ArrowLeft size={26} />
                            </button>
                            <h1 className="text-3xl font-extrabold text-gray-800 text-center w-full">
                                Freelancer Engineer Signup
                            </h1>
                        </div>
                        <div className="flex items-center justify-center mb-8 gap-2 sm:gap-4 w-full px-4 overflow-x-auto">
                            {[1, 2, 3, 4]?.map((num, index) => (
                                <React.Fragment key={num}>
                                    <div
                                        className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center font-bold ${step >= num
                                            ? "bg-gradient-to-r from-blue-600 to-red-500 text-white"
                                            : "bg-gray-200 text-gray-600"
                                            }`}
                                    >
                                        {num}
                                    </div>
                                    {index < 3 && (
                                        <div
                                            className={`flex-1 h-1 sm:h-1.5 ${step > num
                                                ? "bg-gradient-to-r from-blue-600 to-red-500"
                                                : "bg-gray-300"
                                                }`}
                                        />
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                        <h2 className="text-2xl font-bold text-center mb-6">
                            {step === 1 && "Basic Information"}
                            {step === 2 && "Professional Details"}
                            {step === 3 && "Additional Information"}
                            {step === 4 && "ID Information"}
                        </h2>
                        {step === 1 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Full Name <span className="text-red-500">*</span></label>
                                    <input
                                        type="text"
                                        placeholder="Enter your full name"
                                        value={fullName}
                                        onChange={(e) => setFullName(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Email Address <span className="text-red-500">*</span></label>
                                    <input
                                        type="email"
                                        placeholder="Enter email"
                                        value={emailAddress}
                                        onChange={(e) => setEmailAddress(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>


                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Phone Number <span className="text-red-500">*</span></label>
                                    <input
                                        type="number"
                                        placeholder="Enter phone number"
                                        value={phoneNumber}
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>


                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Password <span className="text-red-500">*</span></label>
                                    <input
                                        type="password"
                                        placeholder="Enter password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}

                        {step === 2 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Sub Role</label>
                                    <select
                                        value={subRole}
                                        onChange={(e) => setSubRole(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    >
                                        <option value="">Select a role</option>
                                        {FreelanceRole?.map((role, index) => (
                                            <option key={index} value={role}>
                                                {role}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">State</label>
                                    <select
                                        value={SelectedState}
                                        onChange={(e) => setSelectedState(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        <option value="">Select State</option>
                                        {State?.getStatesOfCountry("IN")?.map((st) => (
                                            <option key={st.isoCode} value={st?.isoCode}>
                                                {st?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">District</label>
                                    <select
                                        value={SelectedDistrict}
                                        onChange={(e) => setSelectedDistrict(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                    >
                                        <option value="">Select District</option>
                                        {Districts?.map((d, idx) => (
                                            <option key={idx} value={d?.name}>
                                                {d?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">City</label>
                                    <select
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                                        value={city}
                                        onChange={(e) => setCity(e.target.value)}
                                    >
                                        <option value="">Select City</option>
                                        {Cities?.map((c, idx) => (
                                            <option key={idx} value={c?.name}>
                                                {c?.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>


                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Pincode</label>
                                    <input
                                        type="text"
                                        placeholder="Enter Pincode"
                                        value={location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Address</label>
                                    <input
                                        type="text"
                                        placeholder="Enter address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Qualifications</label>
                                    <input
                                        type="text"
                                        placeholder="Enter qualifications"
                                        value={qualifications}
                                        onChange={(e) => setQualifications(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Years of Experience</label>
                                    <input
                                        type="number"
                                        placeholder="Enter years of experience"
                                        value={yearsOfExperience}
                                        onChange={(e) => setYearsOfExperience(e.target.value)}
                                        className="w-full h-12 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}

                        {step === 3 && (
                            <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                                <div className="col-span-1 md:col-span-2">
                                    <label className="block mb-2 font-medium text-gray-700">Specializations</label>
                                    <div className="relative">
                                        <button
                                            type="button"
                                            onClick={() => setOpenSpecialization(!openSpecialization)}
                                            className="w-full h-12 px-4 border rounded-xl shadow-sm bg-white text-left flex justify-between items-center focus:ring-2 focus:ring-blue-400"
                                        >
                                            {specializations.length > 0
                                                ? specializations.join(", ")
                                                : "Select Specializations"}
                                            <span className="text-gray-500">&#9662;</span>
                                        </button>
                                        {openSpecialization && (
                                            <div className="absolute mt-2 w-full bg-white border rounded-xl shadow-lg z-20 max-h-56 overflow-y-auto">
                                                {specializationOptions.map((item) => (
                                                    <label
                                                        key={item}
                                                        className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={item}
                                                            checked={specializations.includes(item)}
                                                            onChange={() => handleSpecializationSelect(item)}
                                                            className="w-5 h-5 text-blue-600 border-gray-300 rounded"
                                                        />
                                                        {item}
                                                    </label>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-span-1 md:col-span-2">
                                    <label className="block mb-2 font-medium text-gray-700">Additional Notes</label>
                                    <textarea
                                        placeholder="Enter additional notes"
                                        value={additionalNotes}
                                        onChange={(e) => setAdditionalNotes(e.target.value)}
                                        className="w-full h-24 sm:h-28 md:h-32 px-4 border rounded-xl shadow-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
                                    />
                                </div>
                            </div>
                        )}


                        {step === 4 && (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Upload Portfolio</label>
                                    <div
                                        className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed rounded-2xl cursor-pointer hover:border-blue-500 transition relative overflow-hidden"
                                        onClick={() => document.getElementById("portfolioUpload").click()}
                                    >
                                        {Portfolioupload ? (
                                            Portfolioupload.type.startsWith("image/") ? (
                                                <img
                                                    src={URL.createObjectURL(Portfolioupload)}
                                                    alt="Preview"
                                                    className="object-contain h-full w-full"
                                                />
                                            ) : (
                                                <p className="text-sm text-gray-600">{Portfolioupload.name}</p>
                                            )
                                        ) : (
                                            <>
                                                <Upload />
                                                <p className="text-gray-500">Click to upload</p>
                                            </>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        id="portfolioUpload"
                                        accept=".pdf,.doc,.docx,.jpg,.png"
                                        onChange={(e) => setPortfolioupload(e.target.files[0])}
                                        className="hidden"
                                    />
                                </div>

                                <div>
                                    <label className="block mb-2 font-medium text-gray-700">Upload ID Proof</label>
                                    <div
                                        className="flex flex-col items-center justify-center w-full h-40 border-2 border-dashed rounded-2xl cursor-pointer hover:border-blue-500 transition relative overflow-hidden"
                                        onClick={() => document.getElementById("idUpload").click()}
                                    >
                                        {UploadID ? (
                                            UploadID.type.startsWith("image/") ? (
                                                <img
                                                    src={URL.createObjectURL(UploadID)}
                                                    alt="Preview"
                                                    className="object-contain h-full w-full"
                                                />
                                            ) : (
                                                <p className="text-sm text-gray-600">{UploadID.name}</p>
                                            )
                                        ) : (
                                            <>
                                                <Upload />
                                                <p className="text-gray-500">Click to upload</p>
                                            </>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        id="idUpload"
                                        accept=".pdf,.jpg,.png"
                                        onChange={(e) => setUploadID(e.target.files[0])}
                                        className="hidden"
                                    />
                                </div>
                            </div>
                        )}



                        <div className="mt-10 flex justify-between">
                            {step > 1 && (
                                <button
                                    onClick={() => setStep(step - 1)}
                                    className="px-6 py-2 rounded-full bg-gray-400 text-white hover:bg-gray-500 transition"
                                >
                                    Back
                                </button>
                            )}

                            {step < 4 ? (
                                <button
                                    onClick={() => {
                                        if (validateStep()) {
                                            setStep(step + 1);
                                        }
                                    }}
                                    className="ml-auto px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-red-500 hover:opacity-90 transition"
                                >
                                    Next →
                                </button>
                            ) : (
                                <button
                                    onClick={handleSubmit}
                                    disabled={IsUploading}
                                    className={`ml-auto px-8 py-3 rounded-full text-white font-semibold shadow-lg bg-gradient-to-r from-blue-600 to-red-500 hover:opacity-90 transition flex items-center justify-center ${IsUploading ? "opacity-70 cursor-not-allowed" : ""
                                        }`}
                                >
                                    {IsUploading ? (
                                        <svg
                                            className="animate-spin h-5 w-5 text-white"
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                        >
                                            <circle
                                                className="opacity-25"
                                                cx="12"
                                                cy="12"
                                                r="10"
                                                stroke="currentColor"
                                                strokeWidth="4"
                                            ></circle>
                                            <path
                                                className="opacity-75"
                                                fill="currentColor"
                                                d="M4 12a8 8 0 018-8v8H4z"
                                            ></path>
                                        </svg>
                                    ) : (
                                        "Submit ✅"
                                    )}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FreelancerSignUp;
